module.exports = __webpack_public_path__ + "img/undraw_empty.584b1322.svg";